<template>
<p>Some text about me</p>
</template>

<script setup lang="ts">
</script>

<style scoped>

</style>